import React, { useState } from "react";

// Reused across Admin CRM pages (Inventory pattern).
// Renders an in-app confirmation modal — never uses native window.confirm().
const DeleteConfirmModal = ({ open, recordType, recordLabel, onCancel, onConfirm }) => {
  const [busy, setBusy] = useState(false);
  if (!open) return null;
  const handleConfirm = async () => {
    setBusy(true);
    try { await onConfirm(); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" data-testid="crm-delete-modal">
      <div className="bg-white rounded-sm max-w-md w-full p-6 border hairline shadow-xl">
        <h3 className="font-display text-xl font-semibold text-[#111111]">Delete {recordType}?</h3>
        <p className="text-sm text-[#242424]/80 mt-2">
          This will permanently remove <span className="font-medium text-[#111111]">{recordLabel}</span> from the database. This cannot be undone.
        </p>
        <div className="flex justify-end gap-2 mt-6">
          <button onClick={onCancel} disabled={busy} className="border hairline bg-white text-[#111111] px-4 py-2 rounded-sm text-sm font-semibold disabled:opacity-50" data-testid="crm-delete-cancel">Cancel</button>
          <button onClick={handleConfirm} disabled={busy} className="bg-[#7A1519] hover:bg-[#5a0f12] text-white px-4 py-2 rounded-sm text-sm font-semibold disabled:opacity-50" data-testid="crm-delete-confirm">
            {busy ? "Deleting…" : "Delete permanently"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
